export default __webpack_public_path__ + "static/media/色漫網.7a774ebb.jpg";